/*Import Estilo*/
import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

/*Import Componentes*/
import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';

/*Import Requisição API*/
import api from '../../../../api';
import MenuLateral from '../../../../components/MenuLateral';
import { formatarCpfCnpj } from '../../../../utils/Validadores';

export default function Pedidos() {

    const [pedidos, setPedidos] = useState([]);
    const [usuario_id, setIdUsuario] = useState();
    const [error, setError] = useState(null);

    const [texto, setTexto] = useState('');
    const [pesquisa, setPesquisa] = useState('');
    const navigate = useNavigate();

    const [modalAberto, setModalAberto] = useState(false);
    const [idPedidoParaExcluir, setIdPedidoParaExcluir] = useState(null);
    const caixaDeDialogo = useRef(null);
    const [termoPesquisa, setTermoPesquisa] = useState('');
    const [statusFiltro, setStatusFiltro] = useState('Todos');
    const [loading, setLoading] = useState(true);
    const [ordenacao, setOrdenacao] = useState('mais-novos');
    const [pedidosVistos, setPedidosVistos] = useState(() => {
        try {
            const saved = localStorage.getItem('pedidos_vistos');
            return saved ? new Set(JSON.parse(saved)) : new Set();
        } catch { return new Set(); }
    });

    useEffect(() => {
        caixaDeDialogo.current = document.getElementById('CaixaDeDialogo');
    }, []);

    const abrirModalExcluir = (id_pedido) => {
        setIdPedidoParaExcluir(id_pedido);
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.showModal();
        }
    };

    const fecharModal = () => {
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.close();
        }
        setIdPedidoParaExcluir(null);
    };

    useEffect(() => {
        const buscarDadosUsuario = async () => {
            try {
                const response = await api.get('/usuario', { withCredentials: true });
                console.log("Resposta da API:", response.data);

                if (response.data.success) {
                    console.log('Passei aqui');
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    setIdUsuario(response.data.user.id);
                } else {
                    console.error('Erro na resposta:', response.data);
                }
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
            }
        };

        buscarDadosUsuario();
    }, []);

    const statusCores = {
        'Rascunho': '#9E9E9E',
        'Pedido Efetuado': '#4CAF50',
        'Separado': '#2196F3',
        'Incompleto': '#FF9800',
        'Em Processamento': '#9C27B0',
        'Enviado': '#00BCD4',
        'Entregue': '#8BC34A',
        'Pago': '#4CAF50',
        'Cancelado': '#F44336',
        'Excluído': '#9E9E9E'
    };

    const statusBase = [
        'Todos',
        'Rascunho',
        'Pedido Efetuado',
        'Separado',
        'Incompleto',
        'Enviado',
        'Entregue',
        'Pago',
        'Cancelado'
    ];

    const statusContagens = useMemo(() => {
        const contagens = pedidos.reduce((acc, p) => {
            const status = p.status || 'Sem status';
            acc[status] = (acc[status] || 0) + 1;
            return acc;
        }, {});
        return contagens;
    }, [pedidos]);

    const statusDisponiveis = useMemo(() => {
        const excluidos = new Set(['Excluído', 'Excluido', 'Sem status', 'Em Processamento']);
        const extras = Object.keys(statusContagens)
            .filter(s => !statusBase.includes(s) && !excluidos.has(s));
        return [...statusBase, ...extras];
    }, [statusContagens]);

    const pedidosFiltrados = pedidos.filter(p => {
        const termo = termoPesquisa.toLowerCase();
        const statusMatch = statusFiltro === 'Todos' || !statusFiltro ? true : p.status === statusFiltro;
        const textoMatch = (
            p.nome?.toLowerCase().includes(termo) ||
            p.id?.toString().includes(termo)
        );
        return statusMatch && textoMatch;
    });

    const pedidosOrdenados = useMemo(() => {
        return [...pedidosFiltrados].sort((a, b) => {
            const dA = new Date(a.criado_em);
            const dB = new Date(b.criado_em);
            return ordenacao === 'mais-novos' ? dB - dA : dA - dB;
        });
    }, [pedidosFiltrados, ordenacao]);

    const PRECISA_SEPARAR = ['Pedido Efetuado', 'Pago'];

    const isNovo = (pedido) => !pedidosVistos.has(pedido.id) && PRECISA_SEPARAR.includes(pedido.status);

    const isASeparar = (pedido) => pedidosVistos.has(pedido.id) && PRECISA_SEPARAR.includes(pedido.status);

    const confirmarExcluirPedido = async () => {
        if (!idPedidoParaExcluir) return;

        try {
            await api.delete(`/pedidos/${idPedidoParaExcluir}`);

            setPedidos(prev => prev.filter(p => p.id !== idPedidoParaExcluir));

        } catch (err) {
            if (err.response) {
                const { status, data } = err.response;
                if (status === 404) {
                    alert(data.message || 'Pedido não encontrado — talvez já tenha sido excluído.');
                    setPedidos(prev => prev.filter(p => p.id !== idPedidoParaExcluir));
                } else {
                    alert(`Erro ao excluir pedido: ${data.message || status}`);
                }
            } else {
                alert(`Erro ao excluir pedido: ${err.message}`);
            }
        } finally {
            fecharModal();
        }
    };

    const cadastroPedido = () => {
        navigate('/menu/pedidos/cadastropedido');
    }

    const handleEdit = (id) => {
        console.log(`Editar pedido com ID: ${id}`);
        navigate('/menu/pedidos/editarpedido', { state: { id } });
    };

    const marcarComoVisto = (id) => {
        setPedidosVistos(prev => {
            const next = new Set(prev);
            next.add(id);
            try { localStorage.setItem('pedidos_vistos', JSON.stringify([...next])); } catch {}
            return next;
        });
    };

    const handleView = (id) => {
        marcarComoVisto(id);
        navigate('/menu/pedidos/visualizarpedido', { state: { id } });
    };

    useEffect(() => {
        const fetchPedidos = async () => {
            setLoading(true);
            try {
                const response = await api.get('/pedidosclientes');
                console.log(response.data);

                const pedidos = response.data.pedidos[0];
                console.log('Pedidos:' + pedidos);
                setPedidos(pedidos);
            } catch (error) {
                console.error('Erro ao carregar pedidos:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchPedidos();
    }, []);

    return (
        <section className='container-principal-pedidos'>
            <dialog id="CaixaDeDialogo" className={modalAberto ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <p>Você deseja excluir esse pedido?</p>
                        <div className='bnts-decisao'>
                            <button className="bnt-sim" onClick={confirmarExcluirPedido}>
                                Sim
                            </button>
                            <button className="bnt-nao" onClick={fecharModal}>
                                Não
                            </button>
                        </div>
                    </div>
                </div>
            </dialog>

            <Cabecalho />

            <CookieAceite />

            <main>

                <MenuLateral />

                <section className='conteudo-pedidos'>
                    <div className='titulo-pedidos'><h1>Pedidos</h1></div>
                    <div className='barraDePesquisa-e-criarFuncionarios-container'>
                        <div className='barraDePesquisa-pedidos'>
                            <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.6667 19.6667L28 28M12.7222 22.4444C11.4455 22.4444 10.1812 22.193 9.00169 21.7044C7.82213 21.2158 6.75036 20.4997 5.84757 19.5969C4.94478 18.6941 4.22865 17.6223 3.74006 16.4428C3.25147 15.2632 3 13.999 3 12.7222C3 11.4455 3.25147 10.1812 3.74006 9.00169C4.22865 7.82213 4.94478 6.75036 5.84757 5.84757C6.75036 4.94478 7.82213 4.22865 9.00169 3.74006C10.1812 3.25147 11.4455 3 12.7222 3C15.3007 3 17.7736 4.0243 19.5969 5.84757C21.4201 7.67084 22.4444 10.1437 22.4444 12.7222C22.4444 15.3007 21.4201 17.7736 19.5969 19.5969C17.7736 21.4201 15.3007 22.4444 12.7222 22.4444Z" stroke="#000" stroke-width="4.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                            <input type="text" placeholder="Pesquise pelo: Nome do cliente ou ID do pedido" value={termoPesquisa} onChange={(e) => setTermoPesquisa(e.target.value)} />
                        </div>
                        <div className='controles-ordenacao'>
                            <button
                                className={`bnt-ordenar ${ordenacao === 'mais-novos' ? 'ativo' : ''}`}
                                onClick={() => setOrdenacao('mais-novos')}
                            >Mais Novos</button>
                            <button
                                className={`bnt-ordenar ${ordenacao === 'mais-antigos' ? 'ativo' : ''}`}
                                onClick={() => setOrdenacao('mais-antigos')}
                            >Mais Antigos</button>
                        </div>
                        <button className='bnt-cadastrarPedido' onClick={cadastroPedido}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 4.16667V15.8333M4.16667 10H15.8333" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            Cadastrar Pedido</button>
                    </div>

                    {loading ? (
                        <div className='loading'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 24 24'>
                                <path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' />
                                <path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'>
                                    <animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' />
                                </path>
                            </svg>
                            <h2>Carregando pedidos...</h2>
                        </div>
                    ) : (
                    <>
                    <div className='container-status'>
                        <div className='filtros-status'>
                            {statusDisponiveis.map(status => {
                                const count = status === 'Todos' ? pedidos.length : (statusContagens[status] || 0);
                                const ativo = statusFiltro === status || (status === 'Todos' && (!statusFiltro || statusFiltro === 'Todos'));
                                const desativado = statusFiltro && statusFiltro !== 'Todos' && status !== statusFiltro;
                                const slug = status.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
                                return (
                                    <button
                                        key={status}
                                        className={`chip-status ${ativo ? 'ativo' : ''} ${desativado ? 'desativado' : ''} status-${slug}`}
                                        onClick={() => {
                                            if (statusFiltro === status) {
                                                setStatusFiltro('Todos');
                                            } else {
                                                setStatusFiltro(status);
                                            }
                                        }}
                                    >
                                        <span className='contador-status'>{count}</span>
                                        <span className='nome-status'>{status}</span>
                                    </button>
                                );
                            })}
                        </div>
                        <div className='filtro-status-select-wrapper'>
                            <select
                                className='filtro-status-select'
                                value={statusFiltro}
                                onChange={e => setStatusFiltro(e.target.value)}
                            >
                                {statusDisponiveis.map(status => {
                                    const count = status === 'Todos' ? pedidos.length : (statusContagens[status] || 0);
                                    return (
                                        <option key={status} value={status}>{status} ({count})</option>
                                    );
                                })}
                            </select>
                        </div>
                    </div>

                    <div className="tabela-pedidos">
                        {(pedidosOrdenados?.length ?? 0) === 0 ? (
                            <p>Nenhum pedido encontrado =(</p>
                        ) : (
                            <table>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Nome</th>
                                        <th>Data</th>
                                        <th>Total</th>
                                        <th>
                                            <span className='th-desktop'>Status</span>
                                            <span className='th-mobile'>Nª do Pedido</span>
                                        </th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pedidosOrdenados.map((pedido) => (
                                        <tr className='conteudo' key={pedido.id}>
                                            <td className="coluna-badges">
                                                {isNovo(pedido) && (
                                                    <span className='badge-novo' onClick={(e) => { e.stopPropagation(); marcarComoVisto(pedido.id); }}>NOVO</span>
                                                )}
                                                {isASeparar(pedido) && (
                                                    <span className='badge-a-separar' onClick={(e) => { e.stopPropagation(); handleView(pedido.id); }}>A SEPARAR</span>
                                                )}
                                            </td>
                                            <td className="primeiro">{pedido.nome}</td>
                                            <td>{new Date(pedido.criado_em).toLocaleDateString('pt-BR')}</td>
                                            <td>R$ {pedido.total}</td>
                                            <td>
                                                <span className='celula-status'>{pedido.status}</span>
                                                <span className='celula-id'>#{pedido.id}</span>
                                            </td>
                                            <td className="final">
                                                <div className="bnts-pedidos">
                                                    <button className="bnt-visualizar" onClick={() => handleView(pedido.id)}><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.4375 6.5625C8.4375 6.31527 8.51081 6.0736 8.64817 5.86804C8.78552 5.66248 8.98074 5.50226 9.20915 5.40765C9.43756 5.31304 9.68889 5.28829 9.93137 5.33652C10.1738 5.38475 10.3966 5.5038 10.5714 5.67862C10.7462 5.85343 10.8653 6.07616 10.9135 6.31864C10.9617 6.56111 10.937 6.81245 10.8424 7.04085C10.7477 7.26926 10.5875 7.46449 10.382 7.60184C10.1764 7.73919 9.93473 7.8125 9.6875 7.8125C9.35598 7.8125 9.03804 7.6808 8.80362 7.44638C8.5692 7.21196 8.4375 6.89402 8.4375 6.5625ZM18.4375 10C18.4375 11.6688 17.9427 13.3001 17.0155 14.6876C16.0884 16.0752 14.7706 17.1566 13.2289 17.7952C11.6871 18.4338 9.99064 18.6009 8.35393 18.2754C6.71721 17.9498 5.2138 17.1462 4.03379 15.9662C2.85379 14.7862 2.05019 13.2828 1.72463 11.6461C1.39907 10.0094 1.56616 8.31286 2.20477 6.77111C2.84338 5.22936 3.92484 3.9116 5.31238 2.98448C6.69992 2.05735 8.33122 1.5625 10 1.5625C12.237 1.56498 14.3817 2.45473 15.9635 4.03653C17.5453 5.61833 18.435 7.763 18.4375 10ZM16.5625 10C16.5625 8.70206 16.1776 7.43327 15.4565 6.35407C14.7354 5.27487 13.7105 4.43374 12.5114 3.93704C11.3122 3.44034 9.99272 3.31038 8.71972 3.5636C7.44672 3.81681 6.2774 4.44183 5.35962 5.35961C4.44183 6.27739 3.81682 7.44672 3.5636 8.71972C3.31039 9.99272 3.44034 11.3122 3.93704 12.5114C4.43374 13.7105 5.27488 14.7354 6.35407 15.4565C7.43327 16.1776 8.70206 16.5625 10 16.5625C11.7399 16.5606 13.408 15.8686 14.6383 14.6383C15.8686 13.408 16.5606 11.7399 16.5625 10ZM10.9375 12.8656V10.3125C10.9375 9.8981 10.7729 9.50067 10.4799 9.20765C10.1868 8.91462 9.7894 8.75 9.375 8.75C9.1536 8.74967 8.93923 8.82771 8.76986 8.97029C8.60048 9.11287 8.48703 9.3108 8.4496 9.52901C8.41217 9.74722 8.45318 9.97164 8.56536 10.1625C8.67754 10.3534 8.85365 10.4984 9.0625 10.5719V13.125C9.0625 13.5394 9.22712 13.9368 9.52015 14.2299C9.81317 14.5229 10.2106 14.6875 10.625 14.6875C10.8464 14.6878 11.0608 14.6098 11.2302 14.4672C11.3995 14.3246 11.513 14.1267 11.5504 13.9085C11.5878 13.6903 11.5468 13.4659 11.4346 13.275C11.3225 13.0841 11.1464 12.9391 10.9375 12.8656Z" stroke-width="0.3" /></svg></button>
                                                    <button className="bnt-editar" onClick={() => handleEdit(pedido.id)}><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.4999 5.00007L14.9999 7.50007M10.8333 16.6667H17.4999M4.16659 13.3334L3.33325 16.6667L6.66659 15.8334L16.3216 6.17841C16.634 5.86586 16.8096 5.44201 16.8096 5.00007C16.8096 4.55813 16.634 4.13429 16.3216 3.82174L16.1783 3.67841C15.8657 3.36596 15.4419 3.19043 14.9999 3.19043C14.558 3.19043 14.1341 3.36596 13.8216 3.67841L4.16659 13.3334Z" stroke-width="2.08333" stroke-linecap="round" stroke-linejoin="round" /></svg></button>
                                                    <button className="bnt-excluir" onClick={() => abrirModalExcluir(pedido.id)}><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.6666 9.16667V14.1667M8.33325 9.16667V14.1667M4.99992 5.83333V15.8333C4.99992 16.2754 5.17551 16.6993 5.48807 17.0118C5.80063 17.3244 6.22456 17.5 6.66659 17.5H13.3333C13.7753 17.5 14.1992 17.3244 14.5118 17.0118C14.8243 16.6993 14.9999 16.2754 14.9999 15.8333V5.83333M3.33325 5.83333H16.6666M5.83325 5.83333L7.49992 2.5H12.4999L14.1666 5.83333" stroke-width="2.08333" stroke-linecap="round" stroke-linejoin="round" /> </svg></button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                    </>
                    )}
                </section>

            </main>

            <Rodape />

        </section>
    );
}
